import React, { useState, useRef, useEffect } from "react";

function PinInput({ length = 5, onChange }) {
  const [values, setValues] = useState(Array(length).fill(""));
  const inputRefs = useRef([]);

  useEffect(() => {
    // Focus first input on mount
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (index, value) => {
    // Only allow digits
    if (value && !/^[0-9]$/.test(value)) return;

    const newValues = [...values];
    newValues[index] = value;
    setValues(newValues);

    // Call onChange callback with the full code
    if (onChange) {
      onChange(newValues.join(""));
    }

    // Auto-advance to next input if a digit was entered
    if (value && index < length - 1) {
      // Small delay to ensure the input is updated
      setTimeout(() => {
        inputRefs.current[index + 1]?.focus();
      }, 0);
    }
  };

  const handleKeyDown = (index, e) => {
    // Handle backspace
    if (e.key === "Backspace" && !values[index] && index > 0) {
      // If current input is empty, go to previous and clear it
      e.preventDefault();
      inputRefs.current[index - 1]?.focus();
      const newValues = [...values];
      newValues[index - 1] = "";
      setValues(newValues);
      if (onChange) {
        onChange(newValues.join(""));
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text");
    const digits = pastedData.replace(/\D/g, "").slice(0, length);

    if (digits) {
      const newValues = [...values];
      for (let i = 0; i < digits.length && i < length; i++) {
        newValues[i] = digits[i];
      }
      setValues(newValues);
      if (onChange) {
        onChange(newValues.join(""));
      }
      // Focus the next empty input or the last one
      const nextEmptyIndex = newValues.findIndex(v => !v);
      const focusIndex = nextEmptyIndex === -1 ? length - 1 : nextEmptyIndex;
      inputRefs.current[focusIndex]?.focus();
    }
  };

  return (
    <div className="device-pin-frame">
      {values.map((v, idx) => (
        <input
          key={idx}
          ref={(el) => (inputRefs.current[idx] = el)}
          className={`device-pin-input ${v ? "device-pin-input-filled" : ""}`}
          value={v}
          onChange={(e) => handleChange(idx, e.target.value)}
          onKeyDown={(e) => handleKeyDown(idx, e)}
          onPaste={handlePaste}
          maxLength={1}
          type="text"
          inputMode="numeric"
        />
      ))}
    </div>
  );
}

export default PinInput;

